import { useState } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';

export type DropdownProps = {
  label?: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
  maxWidth?: number;
  /** Options that should render grayed-out and non-selectable. */
  disabledOptions?: string[];
  /** Display text per option value; options without an entry render their value. */
  optionLabels?: Record<string, string>;
  /** Hover text per option value. */
  optionTitles?: Record<string, string>;
};

export function Dropdown({
  label,
  options,
  value,
  onChange,
  maxWidth,
  disabledOptions,
  optionLabels,
  optionTitles,
}: DropdownProps) {
  const [open, setOpen] = useState(false);

  return (
    <FormControl
      fullWidth
      sx={{
        maxWidth: maxWidth || 240,
        mb: 0,
        position: 'relative',
      }}
    >
      {label && (
        <label
          style={{
            fontSize: '14px',
            fontWeight: 500,
            color: 'white',
            marginBottom: '4px',
            display: 'block',
            lineHeight: 1.2,
          }}
        >
          {label}
        </label>
      )}

      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        displayEmpty
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: '#181818',
              color: 'white',
              fontFamily: 'Plus Jakarta Sans',
              fontSize: '13px',
              borderRadius: '8px',
              border: '1px solid #323232',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.6)',
            },
          },
        }}
        sx={{
          height: '40px',
          borderRadius: '8px',
          backgroundColor: '#000',
          color: 'white',
          fontFamily: 'Plus Jakarta Sans',
          fontSize: '14px',
          border: '1px solid #323232',
          pl: '8px',
          pr: '20px',
          display: 'flex',
          alignItems: 'center',
          '& .MuiSelect-select': {
            padding: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
          '& .MuiSelect-icon': {
            color: 'white',
            right: '4px',
            width: '16px',
            height: '16px',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            disabled={disabledOptions?.includes(option)}
            title={optionTitles?.[option]}
          >
            {optionLabels?.[option] ?? option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
